<template>
  <div class="account kbank">
    <div>
      <div class="columns is-mobile">
        <div class="column is-5 is-one-third-mobile">
          <div class="svg"></div>
        </div>
        <div class="column is-7 is-two-third-mobile">
          <div class="bank-detail">
            <div class="bank-name-th">
              {{ depositAccount.bank.nameTH }}
            </div>
            <div class="bank-name-en">
              {{ depositAccount.bank.nameEN }}
            </div>
            <div class="account-name m-t-10">
              {{ depositAccount.bankAccountName }}
            </div>
            <div class="account-no">
              {{ depositAccount.bankAccountNo | bankAccountFormat }}
              <i
                v-if="shouldBankNameEng"
                class="fas fa-copy m-l-10"
                @click="handleEditBankAccountName"
              ></i>
              <i
                v-else
                id="kbankAuto"
                class="fas fa-copy m-l-10"
                v-clipboard:copy="depositAccount.bankAccountNo"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-edit-bank-account-name
      v-if="modalEditBankAccountNameActive"
      :is-active="modalEditBankAccountNameActive"
      :account="account"
      @closeModal="updateBankAccountName"
    />
  </div>
</template>

<script>
import ModalEditBankAccountName from '@/views/user/components/modals/EditBankAccountName'

export default {
  name: 'ModalDeposit',
  components: {
    ModalEditBankAccountName
  },
  props: {
    depositAccount: {
      type: Object
    },
    account: {
      type: Object
    }
  },
  data() {
    return {
      listBankEng: [], //['KTB', 'TMB', 'BBL'],
      modalEditBankAccountNameActive: false,
      shouldBankNameEng: false
    }
  },
  created() {
    if (this.listBankEng.includes(this.account.bankCode)) {
      const re = /^[A-Z\s]+$/i

      if (!re.test(this.account.bankAccountName)) {
        this.shouldBankNameEng = true
      }
    }
  },
  methods: {
    onCopy(e) {
      this.$buefy.toast.open({
        message: `Copied: ${e.text}`,
        type: 'is-success'
      })
    },
    onError() {
      this.$buefy.toast.open({
        message: 'Failed to copy',
        type: 'is-danger'
      })
    },
    handleEditBankAccountName() {
      this.modalEditBankAccountNameActive = true
    },
    updateBankAccountName(name) {
      if (name) {
        this.account.bankAccountName = name

        this.modalEditBankAccountNameActive = false
        this.shouldBankNameEng = false

        setTimeout(() => {
          const id = document.getElementById('kbankAuto')
          id.click()
        }, 1000)
      }
    }
  }
}
</script>
